import { ChangeEvent } from "react";
import { Slider } from "@material-ui/core";

type SeekSliderProps = {
  currentTime: number;
  maxDuration: number;
  onChange: (_ev: ChangeEvent<{}>, value: number | number[]) => void;
};
const SeekSlider = ({ currentTime, maxDuration, onChange }: SeekSliderProps) => (
  <Slider value={currentTime} max={maxDuration} onChange={onChange} step={0.1} />
);

export default SeekSlider;
